import React from 'react'

interface UnauthLayoutProps {
  children: React.ReactNode
}

/**
 * Unauthenticated Layout
 *
 * Provides minimal chrome for unauthenticated pages (login, register):
 * - Centered layout with full-height container
 * - No sidebar, no header/navbar
 * - Branded background with subtle gradient
 * - Responsive container for auth forms
 *
 * This layout is used for all unauthenticated routes (/login, /register)
 */
export function UnauthLayout({ children }: UnauthLayoutProps) {
  return (
    <div className="min-h-screen bg-brand-dark flex items-center justify-center relative overflow-hidden">
      {/* Background Pattern */}
      <div className="absolute inset-0 opacity-5">
        <div className="absolute inset-0 bg-gradient-to-br from-brand-primary/10 via-transparent to-brand-blue/5" />
        <div className="absolute top-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-brand-primary/50 to-transparent" />
      </div>

      {/* Branded Header/Logo */}
      <div className="absolute top-8 left-8 z-10">
        <h1 className="font-display text-2xl font-bold text-brand-primary">
          Monumenta
        </h1>
      </div>

      {/* Auth Content Container */}
      <div className="relative z-10 w-full max-w-md px-4 animate-fade-in-up">
        {children}
      </div>
    </div>
  )
}
